<template>
  <div class="customer-page">
    <div class="customer-page-header">
      <a class="back" @click="iframeForward" href="javascript:;"></a>
      <a class="x" @click="closeAsidePopup" href="javascript:;"></a>
    </div>
    <iframe
      id="customerPageIframe"
      ref="customerPageIframe"
      :src="iframeSrc"
      class="customer-iframe"
      @load="iframeLoad"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      iframeSrc: '',
      canUpdateIframeSrc: true
    }
  },
  computed: {
    ...mapGetters(['asideTiktokPageLink'])
  },
  created() {
    this.iframeSrc = this.asideTiktokPageLink
  },
  methods: {
    closeAsidePopup() {
      this.$store.commit('updateAsideCustomerPageState', {
        visible: false,
        link: ''
      })
    },
    iframeForward() {
      if (!this.canUpdateIframeSrc) {
        return
      }
      this.canUpdateIframeSrc = false
      const url = new URL(this.iframeSrc)
      url.searchParams.set('refreshInTiktok', new Date().getTime())
      this.iframeSrc = url.toString()
    },
    iframeLoad() {
      this.canUpdateIframeSrc = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_dimen';
.customer-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .customer-iframe {
    width: 100%;
    height: calc(100% - 54vh);
    overflow: hidden;
    border: none;
  }
  &-header {
    height: 54vh;
    width: 100%;
    background-color: white;
    font-size: 0;
    margin: 0;
    position: relative;
    .back,
    .x {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      text-decoration: none;
      &:hover {
        cursor: pointer;
      }
    }
    .back {
      background: url($img + 'aside-home.png') no-repeat center center;
      background-size: contain;
      width: 54vh;
      height: 54vh;
      left: 0;
    }
    .x {
      background: url($img + 'aside-close.png') no-repeat center center;
      background-size: contain;
      width: 54vh;
      height: 54vh;
      right: 0;
    }
    .logo {
      height: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
